  <template>
    <div class="admin-layout">
      <!-- Sidebar -->
      <SidebarAdmin />

      <!-- Contenu principal -->
      <section class="main-content">
        <header class="page-header">
          <h2>⚙️ Paramètres</h2>
          <p class="subtitle">Gérez vos informations administrateur, sécurité et notifications</p>
        </header>

        <!-- Informations personnelles -->
        <div class="settings-section">
          <h3>👤 Informations du compte</h3>
          <div class="form-group">
            <label>Nom complet</label>
            <input type="text" v-model="admin.name" placeholder="Nom complet" />
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="email" v-model="admin.email" placeholder="Adresse e-mail" />
          </div>
          <button class="btn-save" @click="updateAdmin">Enregistrer</button>
        </div>

        <!-- Sécurité -->
        <div class="settings-section">
          <h3>🔐 Sécurité du compte</h3>
          <div class="form-group">
            <label>Ancien mot de passe</label>
            <input type="password" v-model="security.oldPassword" placeholder="********" />
          </div>
          <div class="form-group">
            <label>Nouveau mot de passe</label>
            <input type="password" v-model="security.newPassword" placeholder="********" />
          </div>
          <div class="form-group">
            <label>Confirmer le nouveau mot de passe</label>
            <input type="password" v-model="security.confirmPassword" placeholder="********" />
          </div>
          <button class="btn-save" @click="updatePassword">🔄 Mettre à jour le mot de passe</button>
        </div>

        <!-- Notifications -->
        <div class="settings-section">
          <h3>🔔 Notifications</h3>
          <p class="notif-desc">Activez ou désactivez les notifications selon vos préférences :</p>

          <div class="toggle-group" v-for="(setting, key) in notifications" :key="key">
            <label>{{ setting.label }}</label>
            <label class="switch">
              <input type="checkbox" v-model="setting.enabled" />
              <span class="slider"></span>
            </label>
          </div>

          <button class="btn-save" @click="saveNotifications">✅ Enregistrer les préférences</button>
        </div>

        <!-- Système
        <div class="settings-section">
          <h3>🛠️ Informations système</h3>
          <p>Nom de l’application : <strong>SupraCare Dashboard</strong></p>
          <p>Version : <strong>v1.0.0</strong></p>
          <p>Dernière mise à jour : 15 décembre 2025</p>
        </div> 
        -->

        <!-- Déconnexion mobile -->
        <div class="logout-mobile">
          <button @click="logout" class="btn-logout">
            <i class="fas fa-sign-out-alt"></i> Déconnexion
          </button>
        </div>

        <!-- Toast notifications -->
        <transition name="fade">
          <div v-if="toast.visible" :class="['toast', toast.type]">
            {{ toast.message }}
          </div>
        </transition>
      </section>
    </div>
  </template>

  <script>
  import SidebarAdmin from "@/views/admin/SidebarAdmin.vue";

  export default {
    name: "SettingsPage",
    components: { SidebarAdmin },
    data() {
      return {
        admin: {
          name: "Admin SupraCare",
          email: "admin@supracare.com",
        },
        security: {
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        },
        notifications: {
          orders: { label: "Commandes reçues", enabled: true },
          //quotes: { label: "Devis reçus", enabled: true },
          clients: { label: "Nouveaux clients inscrits", enabled: false },
          system: { label: "Mises à jour du système", enabled: true },
        },
        toast: {
          visible: false,
          message: "",
          type: "success",
        },
      };
    },
    methods: {
      showToast(message, type = "success") {
        this.toast.message = message;
        this.toast.type = type;
        this.toast.visible = true;
        setTimeout(() => (this.toast.visible = false), 3000);
      },
      updateAdmin() {
        this.showToast("✅ Informations mises à jour avec succès !");
      },
      updatePassword() {
        if (
          !this.security.oldPassword ||
          !this.security.newPassword ||
          !this.security.confirmPassword
        ) {
          this.showToast("⚠️ Veuillez remplir tous les champs !", "error");
          return;
        }
        if (this.security.newPassword !== this.security.confirmPassword) {
          this.showToast("❌ Les nouveaux mots de passe ne correspondent pas !", "error");
          return;
        }
        this.showToast("✅ Mot de passe mis à jour avec succès !");
        this.security = { oldPassword: "", newPassword: "", confirmPassword: "" };
      },
      saveNotifications() {
        this.showToast("🔔 Préférences de notifications enregistrées !");
      },
      logout() {
        sessionStorage.clear();
        this.showToast("👋 Déconnexion réussie !");
        setTimeout(() => this.$router.push("/connexion"), 1000);
      },
    },
  };
  </script>

  <style scoped>
  /* === LAYOUT === */
  .admin-layout {
    display: flex;
    min-height: 100vh;
    background: #f4f6f9;
    font-family: "Poppins", sans-serif;
    transition: background 0.3s ease, color 0.3s ease;
  }

  .main-content {
    flex: 1;
    padding: 40px;
    background: #ffffff;
    border-radius: 0 16px 16px 0;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.05);
    overflow-x: hidden;
  }

  /* === HEADER === */
  .page-header h2 {
    font-size: 24px;
    color: #00998b;
  }
  .subtitle {
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
  }

  /* === SECTIONS === */
  .settings-section {
    background: #fff;
    padding: 25px;
    border-radius: 12px;
    margin-bottom: 25px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
  .settings-section h3 {
    font-size: 18px;
    color: #00998b;
    margin-bottom: 20px;
  }

  /* === FORM === */
  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
  }
  label {
    font-weight: 500;
    margin-bottom: 6px;
    color: #333;
  }
  input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 14px;
    outline: none;
  }
  input:focus {
    border-color: #00998b;
    box-shadow: 0 0 0 2px rgba(0, 153, 139, 0.15);
  }

  /* === BUTTONS === */
  .btn-save {
    background-color: #00998b;
    color: white;
    border: none;
    padding: 10px 18px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: background 0.3s;
  }
  .btn-save:hover {
    background-color: #007f75;
  }

  /* === NOTIFICATIONS === */
  .notif-desc {
    color: #666;
    font-size: 14px;
    margin-bottom: 15px;
  }
  .toggle-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 24px;
  }
  .switch input {
    opacity: 0;
  }
  .slider {
    position: absolute;
    inset: 0;
    background-color: #ccc;
    border-radius: 24px;
    transition: 0.4s;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #fff;
    border-radius: 50%;
    transition: 0.4s;
  }
  input:checked + .slider {
    background-color: #00998b;
  }
  input:checked + .slider:before {
    transform: translateX(20px);
  }

  /* === LOGOUT MOBILE === */
  .logout-mobile {
    display: none;
    text-align: center;
    margin-top: 20px;
  }
  .btn-logout {
    background: #fff;
    color:black;
    border: none;
    padding: 10px 18px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
  }
  .btn-logout:hover {
    background: #c01a09;
  }

  /* === TOAST === */
  .toast {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 12px 18px;
    border-radius: 8px;
    color: #fff;
    font-weight: 500;
    z-index: 9999;
  }
  .toast.success {
    background: #00998b;
  }
  .toast.error {
    background: #d32f2f;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  /* === RESPONSIVE === */
  @media (max-width: 700px) {
    .main-content {
      padding: 25px;
    }
    .settings-section {
      padding: 20px;
    }
    .btn-save {
      width: 100%;
    }
    .logout-mobile {
      display: block;
    }
  }

  /* === MODE SOMBRE AUTOMATIQUE === */
  @media (prefers-color-scheme: dark) {
    .admin-layout {
      background: #0f1720;
    }
    .main-content {
      background: #1a2532;
      color: #e6edf1;
    }
    .settings-section {
      background: #1f2b3a;
      color: #e6edf1;
    }
    label {
      color: #b0bec5;
    }
    input {
      background: #24313f;
      color: #e6edf1;
      border-color: #3a4a5b;
    }
    input:focus {
      border-color: #00bfa5;
    }
    .page-header h2 {
      color: #00c8b3;
    }
    .btn-save {
      background: #00bfa5;
    }
    .btn-save:hover {
      background: #00a38c;
    }
    .btn-logout {
      background: #3a4a5b;
    }
    .btn-logout:hover {
      background: #3a4a5b;
    }
  }
  </style>
